import { useMemo } from 'react';

import { useQueries } from '@tanstack/react-query';

import getInvoicesWithLineItems from './getInvoicesWithLineItems';
import InvoiceService from '../../../../../../services/InvoiceService';
// import LineItemService from '../../../../../../services/LineItemService';

export default function useInvoiceQueries(distributionPlan) {
  const invoicesIdsWithLineItemsIds =
    getInvoicesWithLineItems(distributionPlan);
  const invoicesIds = Object.keys(invoicesIdsWithLineItemsIds);

  const invoicesQueries = useQueries({
    queries: invoicesIds?.map((invoiceId) => ({
      queryKey: ['invoice', invoiceId],
      queryFn: () => InvoiceService.getInvoice(invoiceId),
      enabled: !!invoiceId,
    })),
  });

  const fetchedInvoices = invoicesQueries?.map((query) => {
    const response = query.data;

    return response;
  });

  return useMemo(() => {
    return fetchedInvoices;
  }, [fetchedInvoices]);
}
